<template>
	<div class="overviews" v-if="stats">
		<div class="row">
			<div class="col-md-12 mb-2" v-if="isShowLabel">
				<span class="text-bold">Product</span>
			</div>
			<div class="col-lg-3 col-md-4 col-6"
				:class="{ 'mw-20': isLengthDivisibleByFive }"
				v-for="(productStatus, objectKey) in excludedOverviews" :key="objectKey">
				<overview :text="productStatus.text"
					:type="'normal'"
					:with-additional="false"
					:number="overviewValue(objectKey)"
					:class="{ 'active' : (clickable && overviewSelected === productStatus.key) }"
					:clickable="clickable"
					@click="actionClick(productStatus.key)"
					:stats="stats"
					:is-fetching="isFetching"
					:info="getOverviewInfo(productStatus)">
				</overview>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-3 col-md-4 col-6"
				:class="{ 'mw-20': isLengthDivisibleByFive }"
				v-for="(productStatus, objectKey) in filteredOverviews" :key="objectKey">
				<overview :text="productStatus.text"
					:type="'normal'"
					:with-additional="false"
					:number="overviewValue(objectKey)"
					:class="{ 'active' : (clickable && overviewSelected === productStatus.key) }"
					:clickable="clickable"
					@click="actionClick(productStatus.key)"
					:stats="stats"
					:is-fetching="isFetching"
					:info="getOverviewInfo(productStatus)">
				</overview>
			</div>
		</div>
	</div>
</template>

<script>
import Overview from '@/components/Overview.vue';
import { duplicateVar } from '@/lib/helper';
import { productOverviewItems, adminOverviewKeys } from '@/lib/statics';

export default {
	components: {
		Overview,
	},
	props: {
		stats: {
			type: Object,
			default: () => { },
		},
		isShowLabel: {
			type: Boolean,
			default: () => true,
		},
		isShowInfo: {
			type: Boolean,
			default: () => true,
		},
		clickable: {
			type: Boolean,
			default: () => false,
		},
		status: {
			type: String,
			default: () => 'all',
		},
		selectedOverviews: {
			type: Array,
			default: () => [],
		},
		isFetching: {
			type: Boolean,
			default: false,
		},
		excludedBoards: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			overviewDisplayData: duplicateVar(productOverviewItems),
			overviewSelected: duplicateVar(this.status),
		};
	},
	methods: {
		overviewValue(key) {
			let countValue = 0;
			if (this.stats.products) {
				countValue = this.stats.products[key];
			}
			return countValue;
		},
		getOverviewInfo(productStatus) {
			return productStatus.info && this.isShowInfo ? productStatus.info : '';
		},
		actionClick(key) {
			this.overviewSelected = key;
			if (this.clickable) {
				this.$emit('action', key);
			}
		},
		getOverviews(exclude) {
			const overviews = {};
			let selectedOverviews = duplicateVar(this.selectedOverviews);

			if (selectedOverviews.length === 0) {
				// default use admin overview keys
				selectedOverviews = adminOverviewKeys;
			}

			if (selectedOverviews.length > 0 && this.overviewDisplayData) {
				Object.entries(this.overviewDisplayData).forEach(([key, value]) => {
					const isExcluded = this.excludedBoards.includes(value.key);
					if (selectedOverviews.includes(value.key) && (exclude ? isExcluded : !isExcluded)) {
						overviews[key] = value;
					}
				});
			}

			return overviews;
		},
	},
	computed: {
		filteredOverviews() {
			return this.getOverviews(false);
		},
		excludedOverviews() {
			return this.getOverviews(true);
		},
		isLengthDivisibleByFive() {
			const isDivisible = Object.keys(this.filteredOverviews).length % 5 === 0;

			return isDivisible;
		},
	},
	watch: {
		status(newStatus) {
			this.overviewSelected = newStatus;
		},
	},
};
</script>

<style scoped>
@media screen and (min-width: 1024px) {
	.mw-20 {
		max-width: 20%
	}
}
</style>
